import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showAlert } from 'actions/app';
import { getBulkSequencesRecommendedDays } from 'services/bulkEmail';

const DEFAULT_TRIGGER_DAYS = {
  default: {
    2: 10,
    3: 15,
    4: 20,
    5: 25
  }
};

export const useGetTriggerDays = ({ scopeTitle, shouldInitRecommendedDays = false }) => {
  const dispatch = useDispatch();
  const [triggerDays, setTriggerDays] = useState(null);

  const recommendedDaysByStep = useMemo(() => {
    if (triggerDays?.default) return triggerDays.default;

    if (scopeTitle && triggerDays) {
      return triggerDays[scopeTitle].DayDelayByAttempt;
    }

    return shouldInitRecommendedDays ? DEFAULT_TRIGGER_DAYS.default : null;
  }, [scopeTitle, shouldInitRecommendedDays, triggerDays]);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      const { success, alert, data } = await getBulkSequencesRecommendedDays();
      if (!isMounted) return;

      if (success) {
        setTriggerDays(data);
      } else {
        setTriggerDays(DEFAULT_TRIGGER_DAYS);
        dispatch(showAlert(alert));
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  return { recommendedDaysByStep };
};
